import OneCInfo from 'components/Mobile/WorkListView/OneCInfo'
import ContractInfo from 'components/Mobile/WorkListView/ContractInfo'
import React, { useEffect, useState } from 'react'
import { Grid } from '@material-ui/core'
import CsContractsService from 'lib/api/services/csContracts.service'

export const WorkList1C = ({ globalId }) => {
  const [agreement, setAgreement] = useState(null)
  const [contract, setContract] = useState(null)

  useEffect(() => {
    if (globalId) {
      CsContractsService.getAgreementByGlobalId(globalId).then(res => {
        if (res.status === 200) {
          setAgreement(res.data || null)
        }
      })

      CsContractsService.getContract(globalId).then(res => {
        if (res.status === 200) {
          setContract(res.data || null)
        }
      })
    }
  }, [globalId])

  return (
    <Grid container spacing={6}>
      <Grid item xs={12} md={6}>
        <OneCInfo listArr={contract?.request1cWorkLists || []} />
      </Grid>
      <Grid item xs={12} md={6}>
        <OneCInfo
          title={'Загрузка запроса на выдачу в 1С'}
          listArr={contract?.request1cSppIssues || []}
        />
      </Grid>
      <Grid item xs={12}>
        <ContractInfo sumDKP={0} paymentData={agreement?.payments} />
      </Grid>
    </Grid>
  )
}
